export default "__VITE_ASSET__G6v1ubzG__"